<template>
  <div class="d-flex-column justify-start align-start gap-5">
    <div class="d-flex-row justify-start gap-5">
      <label for="" class="t-light regular-l font-family-2">
        {{ $t(`${title}`) }}
      </label>
    </div>

    <div
      class="d-flex-row justify-start width-max-content"
      v-for="multiOption in getKeyedPlayoffs"
      :key="multiOption"
    >
      <Checkbox
        variant="secondary"
        type="extra_option"
        :is-checked="isChecked(multiOption.id)"
        :emit-function="emitTrial"
        :selectable-value="multiOption"
        :emit-function-key="multiOption.title"
      />
      <label
        class="medium-l font-family-2 t-white cursor-pointer"
        @click.stop="selectPlayoff(multiOption)"
        >{{ multiOption.title }}
        <span class="t-blue">{{ renderPrice(multiOption) }}</span></label
      >
      <ItemTooltip :text="multiOption.description" />
    </div>
  </div>
</template>

<script setup>
import Checkbox from "~/components/custom/Checkbox.vue";
import ItemTooltip from "./ItemTooltip.vue";
const props = defineProps({
  title: {
    default: "fc-boost.playoffs",
  },
  placeholder: {
    default: "fc-boost.select_playoff",
  },
});

const gameStore = useGameStore();
const checkoutStore = useCheckoutStore();

const getKeyedPlayoffs = computed(() => {
  return gameStore.getGamePack?.pack_options?.filter(
    (op) => op.slug === "champions_finals_extras"
  );
});
const isChecked = (optionId) => {
  return checkoutStore.getPackOptions?.includes(optionId);
};

const isOptionSelected = (packOption) => {
  const selectedOption = checkoutStore.getPackOptions.find(
    (option) => option === packOption
  );
  if (!selectedOption) {
    return false;
  }
  return true;
};

const selectPlayoff = (option) => {
  console.log(option.id);
  if (!isOptionSelected(option.id)) {
    checkoutStore.removePackOption({
      optionIds: option?.rules?.disable || [],
    });

    checkoutStore.setPackOptions({
      options: [...checkoutStore.getPackOptions, option.id],
    });
  } else {
    const otherOptions = checkoutStore.getPackOptions.filter(
      (packOpt) => packOpt !== option.id
    );

    checkoutStore.setPackOptions({
      options: [...otherOptions],
    });
  }
};

const emitTrial = (key, value) => {
  selectPlayoff(value);
};
</script>
